import type { IValidationField } from 'hooks/useValidations/types';
import { t } from 'i18next';
import * as yup from 'yup';

export default function envCropsQuantity({ label = '' }: IValidationField) {
  const validation = yup
    .number()
    .label(label)
    .typeError(t('errors.required'))
    .when('packageReference', {
      is: (val) => !!val,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema,
    })
    .positive();

  return validation;
}
